import { render, staticRenderFns } from "./DropWave.vue?vue&type=template&id=8aeda25e&scoped=true&"
import script from "./DropWave.vue?vue&type=script&lang=ts&"
export * from "./DropWave.vue?vue&type=script&lang=ts&"
import style0 from "./DropWave.vue?vue&type=style&index=0&id=8aeda25e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeda25e",
  null
  
)

export default component.exports